import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import usePermission from "./hooks/usePermission";

const PermissionRoute = ({ permission, children }) => {
  const { token, user } = useAuth();
  const { can } = usePermission();

  if (token && !user) return null;

  return can(permission) ? children : <Navigate to="/unauthorized" replace />;
};

export default PermissionRoute;
